// src/theme.js
import { createTheme } from "@mui/material/styles";

const BRAND = {
  olive: "#757B2B",      // Verde olivo del logo
  oliveDark: "#5F641F",
  oliveLight: "#8E9440",

  coral: "#F3694D",      // Coral/salmón del logo
  coralDark: "#D8573F",
  coralLight: "#F58A76",

  cream: "#FBF7E8",      // crema del fondo del logo
  warmBg: "#F7F5EF",     // fondo app (cálido, no blanco puro)
  ink: "#1E2218",        // texto principal (no negro puro)
  ink2: "#5E6553",       // texto secundario (olivo/gris)
};

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: BRAND.olive,
      dark: BRAND.oliveDark,
      light: BRAND.oliveLight,
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: BRAND.coral,
      dark: BRAND.coralDark,
      light: BRAND.coralLight,
      contrastText: "#FFFFFF",
    },
    background: {
      default: BRAND.warmBg,
      paper: "#FFFFFF",
    },
    text: {
      primary: BRAND.ink,
      secondary: BRAND.ink2,
    },
    divider: "rgba(30,34,24,0.10)",
  },

  // Mantengo tu estilo, solo lo hago un poco más “enterprise”
  shape: { borderRadius: 12 },

  typography: {
    fontFamily: [
      "Inter",
      "system-ui",
      "-apple-system",
      "Segoe UI",
      "Roboto",
      "Arial",
      "sans-serif",
    ].join(","),
    h4: { fontWeight: 800, letterSpacing: -0.6 },
    button: { textTransform: "none", fontWeight: 700 },
  },

  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          border: "1px solid rgba(30,34,24,0.08)",
        },
      },
    },
    MuiTextField: {
      defaultProps: { size: "medium" },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: "rgba(251,247,232,0.55)", // crema sutil (marca)
        },
        notchedOutline: {
          borderColor: "rgba(30,34,24,0.14)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingTop: 10,
          paddingBottom: 10,
        },
        containedPrimary: {
          backgroundColor: BRAND.olive,
        },
        containedSecondary: {
          backgroundColor: BRAND.coral,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: { borderColor: "rgba(30,34,24,0.10)" },
      },
    },
  },
});
